
  import { css } from 'lit';
  export const styles = css`:host{--subtitle-text-color: var(--ig-card-subtitle-text-color, var(--ig-gray-800));--ig-theme: bootstrap;--ig-theme-variant: light}`;
  